import { PollCursor } from '../../_utils/poll-cursor.util'

export interface SitePollResponse {
  data: {
    site: any
    locations: any
    columns: any
    sessions: any
  }
  cursor?: PollCursor
  backfilling: boolean
  id: number
  done: boolean
}

export interface SitePollErrorResponse {
  text: string
}

export enum SitePollRequestType {
  Signin = 1,
  TokenRefresh = 2,
  ForcePoll = 3,
  Signout = 4,
  Backfill = 5,
}

export enum SitePollResponseType {
  Poll = 1,
  TokenRefresh = 2,
  Error = 3,
  ConnectionOk = 4,
  ConnectionError = 5,
}
